// Keep in sync with _variables.scss
export const zIndexDropdown: number = 10;
export const zIndexPopover: number = 20;
export const zIndexTooltip: number = 30;
export const zIndexSticky: number = 100;
export const zIndexFixed: number = 200;
export const zIndexModal: number = 100000;
export const zIndexOverlay: number = 1000000;
